import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey10, orange1 } from 'approot/shared/styles/colours.style';
import {
  spacing16,
  spacing56,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import {
  ACTIVITY_BUILDER_DRAWER_BREAKPOINT,
  ACTIVITY_BUILDER_DRAWER_WIDTH,
  ACTIVITY_BUILDER_SETTINGS_WIDTH,
} from '../activity-builder.constants';
import { PRESENT_PROGRESS_BAR_Z_INDEX } from '../present/activity-builder-present.constants';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

type DraftBannerProps = {
  $isDrawerActive?: boolean;
  $isDrawerDetailsActive?: boolean;
};
export const DraftBanner = styled.div<DraftBannerProps>`
  ${flexCentreAlignCss}

  position: fixed;
  top: ${rem(spacing8)};
  left: 0;
  right: 0;
  background-color: ${orange1};
  color: ${grey10};
  padding: ${rem(spacing16)};
  padding-right: ${rem(spacing56)};
  text-align: center;
  z-index: ${PRESENT_PROGRESS_BAR_Z_INDEX - 1};

  @media (min-width: 650px) {
    padding: ${rem(spacing16)};
  }

  ${ACTIVITY_BUILDER_DRAWER_BREAKPOINT} {
    padding: ${rem(spacing16)};
    right: ${({ $isDrawerActive, $isDrawerDetailsActive }) =>
      $isDrawerDetailsActive
        ? rem(ACTIVITY_BUILDER_SETTINGS_WIDTH + ACTIVITY_BUILDER_DRAWER_WIDTH)
        : $isDrawerActive
          ? rem(ACTIVITY_BUILDER_SETTINGS_WIDTH)
          : 0};
  }
`;
